import { FEEDBACK_COLUMNS } from '@/types/filterKeyConst';

export const STRUCTURED_FILTER_MENU_SECTIONS = {
  firstSection: [
    FEEDBACK_COLUMNS.SOURCE_INFO,
    FEEDBACK_COLUMNS.TAG,
    FEEDBACK_COLUMNS.TAXONOMY_TOPIC,
    FEEDBACK_COLUMNS.PRODUCT,
    FEEDBACK_COLUMNS.SENTIMENT,
    FEEDBACK_COLUMNS.CATEGORY,
    FEEDBACK_COLUMNS.SCORE,
    FEEDBACK_COLUMNS.LANGUAGE,
    FEEDBACK_COLUMNS.CONTENT_ORIGIN,
    FEEDBACK_COLUMNS.HASHTAG,
    FEEDBACK_COLUMNS.KEYWORD,
    FEEDBACK_COLUMNS.MENTION,
    FEEDBACK_COLUMNS.REMARKS,
  ],
  engagementSection: [
    FEEDBACK_COLUMNS.AD_PREDICTION,
    FEEDBACK_COLUMNS.ENGAGEMENT,
    FEEDBACK_COLUMNS.DEMOGRAPHIC,
  ],
  managerSection: [
    FEEDBACK_COLUMNS.CUSTOMER,
    FEEDBACK_COLUMNS.AGENT,
    FEEDBACK_COLUMNS.COMPNAY,
    FEEDBACK_COLUMNS.TICKET_STATUS,
    FEEDBACK_COLUMNS.PRIORITY,
  ],
} as const;
